import { LoginModal } from 'features/auth/ui/login-modal';

export const Login = () => {
  return <LoginModal />;
};
